import { Component, OnInit, Renderer2 } from '@angular/core';
import { CmsmoduleService } from '../../manage/cmsmodule/service/cmsmodule.service';
@Component({
  selector: 'app-refund-policy',
  templateUrl: './refund-policy.component.html',
  styleUrls: ['./refund-policy.component.scss']
})
export class RefundPolicyComponent implements OnInit {
  public loading: boolean;
  public cmsContent;
  public cmsContentData;
  public errorMessage: string;
  constructor(private cmsmoduleService: CmsmoduleService, private renderer: Renderer2,) { }

  ngOnInit(): void {
    this.getCmsContent();
    this.renderer.addClass(document.body, 'stickyHeaderMobile');
  }
  ngOnDestroy() {
    this.renderer.removeClass(document.body, 'stickyHeaderMobile');
  }

  preprocessHtml(html: string): string {
    if (!html) return '';
    try {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const body = doc.body;
      const children = Array.from(body.children);

      let newHtml = '';
      let currentGroupHtml = '';
      let currentHeadingHtml = '';

      const flushGroup = () => {
        if (currentHeadingHtml) {
          newHtml += `<h3 class="sub-title">${currentHeadingHtml}</h3>`;
        }
        if (currentGroupHtml.trim()) {
          newHtml += `<div class="list-alpha">${currentGroupHtml}</div>`;
        }
        currentGroupHtml = '';
        currentHeadingHtml = '';
      };

      children.forEach((child) => {
        const tagName = child.tagName.toLowerCase();
        const textContent = child.textContent || '';
        const innerHtml = child.innerHTML.trim();

        // Ignore empty line spacers
        if (innerHtml === '<br>' || innerHtml === '' || textContent.trim() === '') {
          if (tagName === 'p' && !child.querySelector('strong') && !child.querySelector('b')) {
            return;
          }
        }

        // Check if heading
        const isHeading = tagName === 'h2' || tagName === 'h3' || tagName === 'h4' ||
          (tagName === 'p' && child.querySelector('strong') && /^\d+\.\s+[A-Z\s]+$/.test(textContent.trim()));

        if (isHeading) {
          flushGroup();

          let headingText = child.innerHTML.replace(/<\/?strong>/gi, '').replace(/<\/?b>/gi, '').trim();

          // Format heading to Title Case
          headingText = headingText.replace(/\b([A-Z]+)\b/g, (match) => {
            return match.charAt(0).toUpperCase() + match.slice(1).toLowerCase();
          });
          headingText = headingText.replace(/\bTpl\b/gi, 'TPL');

          currentHeadingHtml = headingText;
        } else {
          // Identify sub-list items starting with roman numerals (e.g. i., ii., etc.)
          const isSubItem = /^[i|v|x]+\.\s+/i.test(textContent.trim());
          if (isSubItem) {
            child.classList.add('sub-list-item');
          }
          currentGroupHtml += child.outerHTML;
        }
      });

      flushGroup();
      return newHtml;
    } catch (e) {
      console.error('Error preprocessing CMS HTML:', e);
      return html;
    }
  }

  getCmsContent() {
    var query = "?filterByDisable=false&filterByStatus=true&filterBySlug=refundpolicies";
    this.cmsmoduleService.getContentDetails(query).subscribe(
      data => {
        this.loading = false;
        this.cmsContent = data.data.items[0];
        if (this.cmsContent != undefined) {
          this.cmsContentData = this.preprocessHtml(this.cmsContent['cmsDescription']);
        }
      },
      err => {
        this.errorMessage = err.error.message;
      });
  }


}
